import * as React from "react";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import IndividualContact from "../../../model/contact/IndividualContact";
import SearchDropdownFilter from "./SearchDropdownFilter";
import {none, option} from "ts-option";
import * as _ from "underscore";

class IndividualContactFilter extends SearchDropdownFilter<IndividualContact> {

	itemToId(item: IndividualContact): string {
		return item.id;
	}


	itemToLabel(item: IndividualContact): string {
		return item.data.displayName();
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.contact.allContactsFetched ? option(_.values(state.contact.individualContactMap)) : none
	};
}

export default connect(mapStateToProps)(IndividualContactFilter)